import styled from 'styled-components';

const container = styled.div`
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
`;

const canvas = styled.div`
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const loading = styled.div`
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 20px;
  color: darkgray;
  text-align: center;
  padding: 30%;
`;

const image = styled.img`
  width: 30%;
  min-width: 100px;
`;

export default { container, canvas, loading, image };



// WEBPACK FOOTER //
// ./src/components/instore/LiveAR/style.js